// People (D114 #6, Console D views/people.js): the app users you looked up lately, remembered on
// this device for each project, only for you. Only the user.hash and when you viewed it are
// kept; storage that is blocked or full leaves the list empty, never an error.
import { APP_USER_HASH } from '../routes/search'

const KEY = (projectId: string) => `apsio.people.${projectId}`
/** How many people the list keeps, the latest first. */
export const MAX_RECENT = 10

export interface RecentPerson {
  hash: string
  /** When you last opened this person, in epoch ms. */
  at: number
}

export function readRecent(projectId: string): RecentPerson[] {
  try {
    const raw: unknown = JSON.parse(localStorage.getItem(KEY(projectId)) ?? '[]')
    if (!Array.isArray(raw)) return []
    return raw
      .filter(
        (x): x is RecentPerson =>
          typeof x?.hash === 'string' &&
          APP_USER_HASH.test(x.hash) &&
          typeof x.at === 'number' &&
          Number.isFinite(x.at),
      )
      .slice(0, MAX_RECENT)
  } catch {
    return []
  }
}

/** Puts `hash` first, viewed `now`. */
export function rememberPerson(projectId: string, hash: string, now = Date.now()): void {
  const next = [{ hash, at: now }, ...readRecent(projectId).filter((x) => x.hash !== hash)]
  try {
    localStorage.setItem(KEY(projectId), JSON.stringify(next.slice(0, MAX_RECENT)))
  } catch {
    // Storage blocked: this visit is not remembered.
  }
}

export function clearRecent(projectId: string): void {
  try {
    localStorage.removeItem(KEY(projectId))
  } catch {
    // Storage blocked: there is nothing to clear.
  }
}

/** A hash the lookup box accepts: trimmed, without a trailing ellipsis the console shortens with. */
export function lookupHash(input: string): string | undefined {
  const v = input.trim().replace(/…$/, '')
  return APP_USER_HASH.test(v) ? v : undefined
}
